import { pipe, map, path } from 'ramda'

export default pipe(
  map(path(['node'])),
  map(p => ({
    ...path(['frontmatter'], p),
    ...path(['fields'], p),
  })),
)
